module.exports = __webpack_public_path__ + "img/head-banner5.56b9ae94.png";